import { createStore } from 'redux';
import thunk from 'redux-thunk';

import { applyMiddleware } from 'helpers/redux_dev_tools';
import rootReducer from './root_reducer';
import { initializeCommission } from './deal/broker_commission_helpers';

export default function (state) {
  for (const commission of state.deal.commissions) {
    initializeCommission(commission);
  }

  const store = createStore(rootReducer, state, applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('./root_reducer', () => {
      store.replaceReducer(require('./root_reducer'));
    });
  }

  return store;
}
